import Accordion from 'accordion-js';

new Accordion(".accordion-container", {
  duration: 600,
  showMultiple: true,
});


